exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video{max-width:720px;min-height:180px;background:#ddd;margin:0 auto}.video,.video iframe{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f5c3a12","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./resources/assets/front/js/components/jj-video/style.less
// module id = 195
// module chunks = 14